import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { PTicketService } from '../../services/p-ticket.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogTitle } from '@angular/material/dialog';
import { pDescription } from '../../interfaces/pDescription';
import { MatFormField } from "@angular/material/form-field";
import { openSnackBar } from '../../helpers/genericFunctions';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { PDescriptionService } from '../../services/p-description.service';
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { NgIf } from '@angular/common';
import { UploadFilesComponent } from '../helpers/upload-files/upload-files.component';

@Component({
  selector: 'app-description-edit-dialog',
  standalone: true,
  imports: [MatFormField, MatDialogContent, MatDialogActions, ReactiveFormsModule, MatButtonModule, MatInputModule, MatRadioGroup, MatRadioButton, NgIf, MatDialogTitle],
  templateUrl: './description-edit-dialog.component.html',
  styleUrl: './description-edit-dialog.component.scss'
})
export class DescriptionEditDialogComponent {
  constructor(
    private formBuilder: FormBuilder,
    private pDescriptionService: PDescriptionService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DescriptionEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { description: pDescription; }
  ) { }


  editpDescriptionForm = this.formBuilder.group(
    {
      pde_description: new FormControl('', Validators.required),
      pde_type: new FormControl('', Validators.required),
    }
  );

  isLoading: boolean = false;

  ngOnInit(): void {
    this.editpDescriptionForm.patchValue({
      "pde_description": this.data.description.pde_description,
      "pde_type": this.data.description.pde_type
    })
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onTextareaKeydown(event: KeyboardEvent): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.onUpdateDescription();
    }
  }
  onUpdateDescription(): void {
    if (this.editpDescriptionForm.valid) {
      this.isLoading = true;
      let payload = {
        pde_description: this.editpDescriptionForm.controls.pde_description.value,
        pde_type : this.editpDescriptionForm.controls.pde_type.value
      }
      this.pDescriptionService.update(payload, this.data.description.id).subscribe(
        response => {
          openSnackBar("Descripiton changed", 2000, this.snackBar);
          this.dialogRef.close(response);
          this.isLoading = false;
        },
        error => {
          openSnackBar("Error while changing descripiton" + error, 5000, this.snackBar);
          this.isLoading = false;
        }
      );
    }
  }
}
